<i18n>
{
  "fr": {
    "Title": "Rapport de bugs"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title')"/>
    <AppContainer>
      <UserGenerateForm
        @submit="setUser" />
      <DateGenerateForm
        @submit="setDates"/>
      <div>
        <ButtonGenerate
          @click="generate" />
      </div>
    </AppContainer>
  </section>
</template>

<script>
import UserGenerateForm from '@/components/reports/UserGenerateForm';
import DateGenerateForm from '@/components/reports/DateGenerateForm';

export default {
  components: {
    UserGenerateForm,
    DateGenerateForm,
  },
  data() {
    return {
      form: {
        user: null,
        startDate: null,
        endDate: null,
      },
    };
  },
  methods: {
    setDates(dates) {
      this.form.startDate = dates.startDate;
      this.form.endDate = dates.endDate;
    },
    setUser(user) {
      this.form.user = user.user;
    },
    generate() {
      if (this.form.user) {
        this.$router.push({ name: 'Bug-Global', query: this.form });
      } else {
        this.$router.push({ name: 'BugAll', query: this.form });
      }
    },
  },
};
</script>
